import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.528 2.195c.26-.26.683-.26.943 0l3.333 3.334c.26.26.26.682 0 .942l-3.333 3.334a.667.667 0 1 1-.943-.943L12.39 6 9.528 3.138a.667.667 0 0 1 0-.943",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.333 6.666a2 2 0 0 0-2 2v4.667a.667.667 0 0 1-1.333 0V8.666a3.333 3.333 0 0 1 3.333-3.333h8a.667.667 0 0 1 0 1.333z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })